import BidAmountChecker from './bid_amount_checker';
import Countdown from './countdown';

const placeButton = 'a[data-bind=\'place-bid\']';
const placeBidForm = '#place-bid-form';
const bidInput = 'input[name=\'max_bid\']';

function showBiddingLightbox(e) {
  e.preventDefault();
  Reverb.UI.Ajax.lightbox(dialogFetchUrl(), lightboxCallbacks);
}

function lightboxCallbacks() {
  BidAmountChecker.checkBidAmount();
  Countdown.init();
}

function bindPlaceBid() {
  $(document).on('submit', placeBidForm, showBiddingLightbox);
  $(document).on('click', placeButton, showBiddingLightbox);
}

function dialogFetchUrl() {
  return $(placeButton).prop('href') + bidProperty();
}

function bidProperty() {
  return inputBidValue() ? (`?bid=${inputBidValue()}`) : '';
}

function inputBidValue() {
  return $(bidInput).val();
}

function init(options) {
  bindPlaceBid();
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/auctions/bid_placement.js